export default __webpack_public_path__ + "static/media/MdAmanullahParvez_Web_Developer_27_11_2021.98991b9e.pdf";